//@ts-ignore
import Checkbox from './checkbox';

export default Checkbox;
